import React, { Component } from 'react';
import { DataContext } from '@philips-internal/oswald-ui-core/lib/component/context/index.js';
import { bool, fragment, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { isContentfulString, noop } from '@philips-internal/oswald-ui-utils';
import { EngineContext } from '../contexts/engine-context.js';
function baseFragmentError(message) {
    return new Error(`[BaseFragment]: ${message}`);
}
class BaseFragment extends Component {
    constructor() {
        super(...arguments);
        this.unlisten = noop;
        this.updateContextData = (data) => {
            this.setState({ contextData: data });
        };
    }
    componentDidMount() {
        void this.loadFragmentAsync();
    }
    componentDidUpdate(prevProps) {
        if (this.props.fragment !== prevProps.fragment) {
            if (prevProps.fragment) {
                this.discardFragmentInstance();
            }
            void this.loadFragmentAsync(true);
        }
    }
    componentWillUnmount() {
        if (this.props.disposable) {
            this.unlisten();
            this.discardFragmentInstance();
        }
    }
    discardFragmentInstance() {
        this.context.engine?.discardFragment(this.props.uuid);
    }
    async loadFragmentAsync(forceLoad = false) {
        const { engine, root } = this.context;
        if (!engine) {
            throw baseFragmentError('No engine provided.');
        }
        const { content } = this.state;
        if (content && !forceLoad) {
            return;
        }
        const { contextData, fragment, uuid } = this.props;
        const emptyFragment = {
            content: null,
            contextData: {},
            loaded: false,
            node: null,
        };
        if (!isContentfulString(fragment)) {
            return this.setState(emptyFragment);
        }
        const metadata = await engine.getFragmentMetadata(fragment);
        if (!metadata) {
            return this.setState(emptyFragment);
        }
        const node = await this.provideFragment(engine, {
            contextData,
            fragment,
            instanceUUID: uuid,
            root,
        });
        const fragmentContent = this.renderFragment(node);
        const dataContext = node.getDataContext();
        this.unlisten();
        this.unlisten = dataContext.addListener(this.updateContextData);
        this.setState({
            content: fragmentContent,
            contextData: dataContext.getBulkData(),
            loaded: true,
            node,
        });
    }
    renderFragment(fragment) {
        const root = fragment.getMetadata().getRoot();
        if (this.context.engine) {
            return this.context.engine.render(root);
        }
        throw Error('[BaseFragment]: No engine provided.');
    }
    render() {
        const { content, contextData, node } = this.state;
        const engineValue = {
            engine: this.context.engine,
            root: node,
        };
        return (React.createElement(EngineContext.Provider, { value: engineValue },
            React.createElement(DataContext.Context.Provider, { value: contextData }, content)));
    }
}
BaseFragment.contextType = EngineContext;
BaseFragment.propTypes = {
    disposable: bool,
    fragment: fragment,
    instanceUUID: string.notEnumerable(),
    uuid: string,
};
BaseFragment.defaultProps = {
    disposable: true,
};
export { BaseFragment, };
//# sourceMappingURL=base-fragment.js.map